import React, { Component } from "react";
import { Grid, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { firestoreConnect, isEmpty } from "react-redux-firebase";
import { compose } from "redux";
import UserDetailedHeader from "./UserDetailedHeader";
import UserDetailedDescription from "./UserDetailedDescription";
// import UserDetailedSidebar from "./UserDetailedSidebar";
import UserDetailedTests from "./UserDetailedTests";
import UserActivityDashboard from "./UserActivity/UserActivityDashboard/UserActivityDashboard";
import { userDetailedQuery } from "./userQueries";
import {
    getActivityList,
    getAttendedTest,
    getSubjectWiseTest
} from "./UserDetailActions";
import { createTestTree } from "../../features/userTestTree/userTestTreeActions";

const mapState = (state, ownProps) => {
    let userUid = null;
    let profile = {};
    let id = ownProps.match.params.id;
    // console.log("id im looking for", ownProps.match.params.id);

    if (ownProps.match.params.id === state.auth.uid) {
        profile = state.firestore.profile;
    } else {
        profile =
            !isEmpty(state.firestore.ordered.profile) &&
            state.firestore.ordered.profile[0];
        userUid = ownProps.match.params.id;
    }
    // console.log(
    //     isEmpty(state.firestore.ordered.profile) ? "empty" : "not empty"
    // );
    return {
        id,
        profile,
        userUid,
        auth: state.firebase.auth,
        testLoading: state.async.loading,
        loadingActivities: state.async.loadingActivities,
        userDetailActivity: state.userDetail.fetchActivities,
        testAttended: state.userDetail.testAttended
    };
};

const actions = {
    getActivityList,
    getAttendedTest,
    getSubjectWiseTest,
    createTestTree
};

class UserDetailedPage extends Component {
    state = {
        id: this.props.id,
        moreActivities: false,
        loadingInitial: true,
        testAttended: [],
        viewRecectActivity: false
    };

    async componentDidMount() {
        const { auth } = this.props;
        try {
            console.log("getActivityList() entered ");
            let next = await this.props.getActivityList(this.props.id);
            if (next && next.docs && next.docs.length > 1) {
                this.setState({
                    moreActivities: true,
                    loadingInitial: false,
                    testAttended: this.props.testAttended
                });
            }
        } catch (error) {
            console.log("getActivityList() error in componentDidMount");
        }

        try {
            console.log("getAttendedTest() entered ");
            await this.props.getAttendedTest(this.props.id);
        } catch (error) {
            console.log("getAttendedTest() error in componentDidMount");
        }

        try {
            console.log("createTestTree() entered ");
            await this.props.createTestTree(auth.uid);
        } catch (error) {
            console.log("createTestTree() error in componentDidMount");
        }
    }

    async componentWillReceiveProps(props) {
        const { id } = this.props;

        if (props.id !== id) {
            console.log("props id & id ", props.id, id);
            this.setState({
                id: props.id
            });

            try {
                console.log("called getAttendedTest()");
                await this.props.getAttendedTest(props.id);
            } catch (error) {
                console.log("getAttendedTest() fetching ", error);
            }
            try {
                console.log("called getActivityList()");
                await this.props.getActivityList(props.id);
            } catch (error) {
                console.log("getActivityList() fetching ", error);
            }
        }
    }

    handleViewRecentActivity = () => {
        this.setState({
            viewRecectActivity: !this.state.viewRecectActivity
        });
    };

    render() {
        // const { auth, match } = this.props;
        const {
            profile,
            testLoading,
            getSubjectWiseTest,
            getAttendedTest
        } = this.props;
        // const isCurrentUser = auth.uid === match.params.id;
        // console.log("id looking ", this.state.id, profile);
        // this.getNewData(this.state.id);
        // console.log("profile ", profile);
        return (
            <div>
                <Grid>
                    <UserDetailedHeader profile={profile} />
                    <UserDetailedDescription profile={profile} />
                    {/* <UserDetailedSidebar isCurrentUser={isCurrentUser} /> */}
                    <UserDetailedTests
                        testLoading={testLoading}
                        getSubjectWiseTest={getSubjectWiseTest}
                        getAttendedTest={getAttendedTest}
                        profile={profile}
                    />
                </Grid>
                <Grid>
                    <Grid.Column width={16}>
                        <Button
                            primary
                            onClick={this.handleViewRecentActivity}
                            style={{
                                width: "100%",
                                marginTop: "20px",
                                marginBottom: "20px"
                            }}
                        >
                            {!this.state.viewRecectActivity
                                ? "View Recent Activity"
                                : "Hide Recent Activity"}
                        </Button>
                        {this.state.viewRecectActivity && (
                            <UserActivityDashboard
                                userId={this.state.id}
                                profile={profile}
                            />
                        )}
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

export default compose(
    connect(
        mapState,
        actions
    ),
    firestoreConnect((auth, userUid) => userDetailedQuery(auth, userUid))
)(UserDetailedPage);
